function initContactAccordion() {
    const items = document.querySelectorAll(".contact-accordion__item");

    if (!items.length) {
        return;
    }

    const updateHeight = (item) => {
        const content = item.querySelector(".contact-accordion__content");
        if (!content) return;
        if (item.classList.contains("is-open")) {
            content.style.maxHeight = `${content.scrollHeight}px`;
        } else {
            content.style.maxHeight = "0px";
        }
    };

    items.forEach((item) => {
        const trigger = item.querySelector(".contact-accordion__trigger");
        if (!trigger) return;

        updateHeight(item);

        trigger.addEventListener("click", () => {
            const isOpen = item.classList.toggle("is-open");
            trigger.setAttribute("aria-expanded", String(isOpen));
            updateHeight(item);
        });
    });

    window.addEventListener("resize", () => {
        items.forEach(updateHeight);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactAccordion);
} else {
    initContactAccordion();
}

export default initContactAccordion;
